import { render, staticRenderFns } from "./StudentLoanPayment.vue?vue&type=template&id=19534fda&scoped=true&"
import script from "./StudentLoanPayment.vue?vue&type=script&lang=js&"
export * from "./StudentLoanPayment.vue?vue&type=script&lang=js&"
import style0 from "./StudentLoanPayment.vue?vue&type=style&index=0&id=19534fda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19534fda",
  null
  
)

export default component.exports